import { SEARCH_PARAMETERS } from "../searchResults/constants";
import { LineOfBusinessConfig } from "../claimsSearchBar/legacySearchBarSupport";
import { ROUTES } from "src/app/constants";

export const CLAIMS_LIMIT = 100;

// IPL-specific search configuration
export const IPL_LINE_OF_BUSINESS_CONFIG: LineOfBusinessConfig = {
  searchByLabels: {
    [SEARCH_PARAMETERS.ORDER_ID]: {
      buttonText: "Search",
      buttonTextSmall: "Search",
      placeholder: "Search for IPL claims using the Order ID",
      placeholderSmall: "Search by Order ID",
    },
  },
  availableSearchParameters: [SEARCH_PARAMETERS.ORDER_ID],
  routePath: ROUTES.IPL_CLAIMS_HISTORY,
  metricsPrefix: "ipl",
};
